





























































































import { Component, Vue, Watch, Mixins } from 'vue-property-decorator';
// import { LocalDateTime } from 'js-joda';
import { findIndex, map } from 'lodash';
import TimeMixin from '@/assets/ts/mixins/TimeMixin.ts';
import MobileDetectionMixin from '@/assets/ts/mixins/MobileDetectionMixin.ts';
import AssetMixin from '@/assets/ts/mixins/AssetMixin.ts';
import CertificateInformation from '@/components/certificate/CertificateInformation.vue';
import HistoryItemData from '@/components/certificate/HistoryItemData.vue';
import FlatButtonWithIcon from '@/components/FlatButtonWithIcon.vue';
import UpdateField from '@/components/certificate/UpdateField.vue';
// import Share from '@/components/share/Share.vue';
import { EventBus } from '@/plugins/event-bus';
import { IAsset, IHistory } from '@/store/modules/asset/interface';
import { MUTATE_LISTENER_STATE } from '@/store/modules/listener';
import { AssetState } from '@/assets/ts/model/AssetState';
import { Papybase, PapybaseConfig, VerifyPayload, VerifyInfo, CertificateInfo } from '@luxtag/papybase';
import moment from 'moment';

@Component({
  components: {
    CertificateInformation,
    HistoryItemData,
    UpdateField,
    // Share,
    FlatButtonWithIcon
  },
  filters: {
      date(val: string) {
          return moment(val).format;
      },
  }
})
export default class CertificatePage extends Mixins(MobileDetectionMixin, AssetMixin, TimeMixin) {
    public transactions: any[] = [];
    public filteredHistories: IHistory[] = [];
    public view = 0;
    public isCertificateView = true;
    public showUpdateFieldDialog = false;
    public verifyInfo: VerifyInfo | null  = null;

    public async fetchCertificate() {
        const verifyPayload: VerifyPayload = {
            uuid: this.uuid,
            merchant: this.merchant,
            address: this.address,
        };

        if (this.xVersion === 1) {
            this.verifyInfo = await this.papybaseX1.uuid().verifyUUID(verifyPayload);
        } else if (this.xVersion === 2) {
            this.verifyInfo = await this.papybaseX2.uuid().verifyUUID(verifyPayload);
        } else {
            this.verifyInfo = await this.papybaseX3.uuid().verifyUUID(verifyPayload);
        }

        if (!this.verifyInfo.verified) {
            this.$router.push({name: 'fake', query: { merchant: this.merchant }});
        }
    }

    public initCertificatePage(certificateId: string) {
        // get the transactions from store
        this.transactions = this.$store.getters.getAssetRawHistory(certificateId);

        // init public account
        try {
            // const certificateAccount = PublicAccount.createFromPublicKey(certificateId, NetworkType.MIJIN_TEST);

            // // update cert info from blockchain
            // this.filterAssets([certificateAccount]).then((assets) => {
            //     if (assets.length) {
            //         this.transactions = assets[0].transactions;
            //         this.storeAssetsInfo(assets);
            //     } else {
            //         this.assetNotFound();
            //     }
            // });
        } catch (error) {
            this.assetNotFound();
        }
    }

    public assetNotFound() {
        this.$router.push(`/404`);
    }

    public getPublicAccount(pubKey: string): any {
        return {};
        // return PublicAccount.createFromPublicKey(pubKey, NetworkType.MIJIN_TEST);
    }

    public beforeRouteEnter(to: any, from: any, next: any) {
        next((vm: any) => {
            // access to component instance via `vm`
            EventBus.$emit('change-hide-slider', true);
            EventBus.$emit('change-show-tab-active-color', false);
        });
    }

    public beforeRouteLeave(to: any, from: any, next: any) {
        EventBus.$emit('change-hide-slider', false);
        EventBus.$emit('change-show-tab-active-color', true);
        next();
    }

    public changeView(index: number) {
        // 0 is certificate & 1 is history
        this.view = index;
    }

    public certificateBtnClicked() {
        this.isCertificateView = true;
    }

    public historyBtnClicked() {
        this.isCertificateView = false;
    }

    public filterHistory(transaction: any): IHistory | undefined {
        const history: IHistory = {
            header: '',
            imgs: [],
            time: moment(),
            iconId: '',
            hash: '',
        };

        if (transaction.transactionInfo) {
            if (transaction.transactionInfo.hash) {
                history.hash = transaction.transactionInfo.hash;
            }
        }

        history.time = transaction.deadline.value;

        if (transaction) {
            // const message = messageFromSerializedObject(JSON.parse(transaction.message.payload));
            // if (message instanceof CreationMessage) {
            //     history.header = 'This is where everything started';
            //     history.iconId = 'i91';

            //     return history;
            // } else if (message instanceof PostMessage) {
            //     history.header = 'You posted a memo';
            //     history.content = message.content;
            //     if (message.imgs) {
            //         history.imgs = message.imgs;
            //     }
            //     history.iconId = 'i93';

            //     return history;
            // } else if (message instanceof ReviewMessage) {
            //     history.header = 'You posted a review';
            //     history.content = message.comment;
            //     history.rating = message.rate;
            //     history.iconId = 'i93';

            //     return history;
            // } else {
                return;
            // }
        } else if (transaction) {
            const txModifications = transaction.modifications;
            if (txModifications.length === 1) {
                if (txModifications[0].type === 0) {
                    // claims
                    history.header = 'Claim';
                    history.content = 'The first time the asset has been claimed';
                    history.iconId = 'i92';

                    return history;
                } else {
                    return;
                }
            } else if (txModifications.length === 2) {
                if (txModifications[0].type !== txModifications[1].type) {
                    // transfer from type 1 to 0
                    history.header = 'Transfer';
                    history.header = 'Owner has transferred this to new Owner';
                    history.iconId = 'i91';

                    return history;
                } else {
                    return;
                }
            } else {
                return;
            }
        } else {
            return;
        }
    }

    public getIconId(historyType: string) {
        switch (historyType.toUpperCase()) {
            case 'CLAIM':
                return 'i92';
            case 'TRANSFER':
                return 'i91';
            case 'CREATION':
                return 'i91';
            default:
                return 'i93';
        }
    }

    @Watch('verifyInfo', { immediate: true, deep: true })
    private onVerifyInfoChange(val: VerifyInfo | null) {
        if (val) {
            this.filteredHistories = map(val.activities, (activity) => {
                return {
                    hash: activity.tx_hash,
                    header: activity.type,
                    time: moment(activity.timeStamp),
                    content: activity.message,
                    iconId: this.getIconId(activity.type),
                };
            });
        }
    }

    @Watch('$route.query', { immediate: true, deep: true })
    private onCertificateIDChanged(val: any, oldVal: any) {
        this.fetchCertificate();
        // this.initCertificatePage(val);
    }

    get papybaseX1(): Papybase {
        const papybaseConfig: PapybaseConfig = {
            baseURL: 'https://api.event.luxtag.io',
            timeout: 8000,
        };

        return Papybase.initializeApp(papybaseConfig);
    }

    get papybaseX2() {
        const papybaseConfig: PapybaseConfig = {
            baseURL: 'https://x2.event.luxtag.io',
            timeout: 8000,
        };

        return Papybase.initializeApp(papybaseConfig);
    }

    get papybaseX3() {
        const papybaseConfig: PapybaseConfig = {
            baseURL: 'https://api.horizon.luxtag.io',
            timeout: 8000,
        };

        return Papybase.initializeApp(papybaseConfig);
    }

    get queries() {
        return this.$route.query;
    }

    get address() {
        return this.$route.query.a;
    }

    get xVersion(): number {
        return Number(this.$route.query.v);
    }

    get merchant() {
        return this.$route.query.m;
    }

    get uuid() {
        return this.$route.query.u;
    }

    get certificateId() {
        return this.$route.params.certificateId;
    }

    get isListenerOpen() {
        return this.$store.getters.getListenerState;
    }

    get testIcon() {
        return `$vuetify.icons.${this.$store.getters.getIcon('i91')}`;
    }

    get certificateMobileView() {
        // this method will control mobile version of certificate/history state
        if (this.isMobile) {
            return this.view === 0;
        } else {
            return true;
        }
    }

    get historyMobileView() {
        // this method will control mobile version of certificate/history state
        if (this.isMobile) {
            return this.view === 1;
        } else {
            return true;
        }
    }

    get histories(): IHistory[] {
        const histories: IHistory[] = [];
        for (const transaction of this.transactions) {
            const history = this.filterHistory(transaction);
            if (history) {
                histories.push(history);
            }
        }

        return histories;
    }

    get theMobile() {
        return this.isMobile;
    }

    get transferAssetList(): any[] {
        // const muxAcc = PublicAccount.createFromPublicKey(
        //     this.certificateId,
        //     NetworkType.MIJIN_TEST,
        // );

        // const mux: any = {
        //     account: muxAcc,
        //     state: AssetState.NORMAL,
        // };

        return [];
    }

    // get multisigAccounts(): any[] {
    //     return this.$store.getters.getMultisigAccounts;
    // }
}
